import type { JsonObject } from '@/app-package';
import type { TeamDoc } from '@bb/domain/dist/schemas';
import type { IGenericUser } from '@bb/users';
import axios from 'axios';

export type ResultType = (JsonObject<TeamDoc> & { users: IGenericUser[] })[];

const getMultipleTeams = async (teamIds: string[]) => {
  const { data } = await axios.get<ResultType>(`/team/batch`, {
    params: { teamIds },
  });
  return data;
};

export default getMultipleTeams;
